<template>
  <div>
    登录验证中。。
  </div>
</template>

<script>
  import loginUtil from "@/util/loginUtil";

  export default {
    data() {
      return {
        token: "",
      };
    },
    mounted() {
      this.token = this.$route.query.token;
      if (this.token) {
        this.login();
      } else {
        this.$message.error("token不能为空");
      }
    },
    methods: {
      login() {
        let params = {
          "token": this.token,
        };
        this.$http
          .get("basic", "account/loginByToken", params)
          .then(data => {
            loginUtil.login(data);
            this.$router.push({path: "/"});
          }).catch((err) => {
            this.$message.error("登录失败", err);
          });
      },
    },
  };
</script>

<style lang="scss" scoped>
</style>
